export const KrushiSetu = '/Icon krushisetu.png'
